/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*
* You can also add a listener whenever a product is added to the cart:
*
* document.addEventListener('product:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
*   var quantity = event.detail.quantity; // Get the quantity that was added
* });
*
* If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
* you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
* that was added so the theme can properly update the quantity:
*
* document.documentElement.dispatchEvent(new CustomEvent('product:added', {
*   bubbles: true,
*   detail: {
*     quantity: 1
*   }
* }));
*
* If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
* "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
*
* document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
*   bubbles: true
* }));
*/

var getProductCards = setInterval(function () {
    if (jQuery('#fast-simon-serp-app')[0]) {
        var productGrid = jQuery('#fast-simon-serp-app')[0].shadowRoot.querySelector('#fs-serp-page');
        if (productGrid) {
            var productCards = productGrid.querySelectorAll('.product-card');
            productCards.forEach(function(k,v){
                var element = jQuery(k);
                if ( element.find('.out-of-stock-wrapper').length > 0 ) {
                    // EDITS HERE: 
                    element.find('.fs-product-main-image-wrapper').css('opacity', '0.4'); 
                }
            })
        }
    }
    else {
    }
}, 150);

$(document).ready(function(){
    $('.shopify-section').each(function(){
        var section = $(this);
        if (section.find('a').length > 0) {         
            section.find('a').each(function(){
                if ($(this).attr('href')) { 
                    var link = $(this);
                    var href = link.attr('href');
                    if (href.indexOf('#') > -1) {
                        link.on('click',function(){
                            var hash = href.split('#')[1];
                            var target = $('#'+hash);
                            if (target.length > 0) {
                                $('html, body').animate({
                                    scrollTop: target.offset().top - 150
                                }, 500);
                            }
                        })
                    }
                }
            })}
        });
    })
    
    document.addEventListener('DOMContentLoaded', function () {
        let topMenu = document.querySelector('.nav-bar__linklist');
        let dataLayer = []
        
        topMenu.addEventListener('click', (e) => {
            if (e.target.tagName === 'A') {
                // Enable this to prevent the link from opening / testing
                // e.preventDefault();
                //
                let parentItem = e.target.closest('.nav-bar__item--static').querySelector('A').innerText;
                let clickedItem = e.target.innerText;
                let subMenuItem = e.target.closest('.mega-menu__column') ? e.target.closest('.mega-menu__column').querySelector('A').innerText : e.target.closest('.nav-bar__item--static').querySelector('A').innerText;
                let collectionLink = '';
                
                collectionLink = e.target.href;
                
                //console.log(`Parent Item: ${parentItem}`);
                //console.log(`Sub Item: ${subMenuItem}`);
                //console.log(`Tertiary Item: ${clickedItem}`);
                //console.log(`Clicked Link: ${collectionLink}`);
                window.dataLayer = window.dataLayer || [];
                
                window.dataLayer.push({
                    event: "navigation",
                    'nav_top': parentItem,
                    'nav_sub': subMenuItem,
                    'nav_tertiary': clickedItem,
                    'nav_category_url': collectionLink,
                })
            }
            //alert('clicked')
            console.log(dataLayer)
        });
    });
    
    // Fast Simon SPA Content Change fix
    
    async function afterNavigation(event) {
        var sectionElementIds = [
            'shopify-section-collection-title',
            'template--16256015106227__5cd7ca54-2c7d-4d8b-be1d-9896257d40f5'
        ];
        
        var sectionIdToPosition = {
            'shopify-section-collection-title': 'before',
        }
        
        var collectionTitle = document.querySelector('.collection-title-wrap');
        
        // remove node collection title
        
        if (collectionTitle) {
            collectionTitle.remove();
        }
        
        for(var sectionElementID of sectionElementIds) {
            var sectionID = sectionElementID.replace('shopify-section-', '');
            var sectionElement = document.getElementById(sectionElementID);
            var sectionEndpoint = location.pathname + '?sections=' + sectionID;
            var sectionResponse = await fetch(sectionEndpoint);
            var sectionDataDict = await sectionResponse.json();
            var sectionElement = sectionElement ? sectionElement : document.querySelector('.collection-title-section');
            if(sectionElement) {
                sectionElement.outerHTML = sectionDataDict[sectionID]; 
            } else {
                sectionElement = document.createElement('div');
                sectionElement.id = sectionElementID;
                sectionElement.innerHTML = sectionDataDict[sectionID];
                var elementPosition = sectionIdToPosition[sectionElementID];
                var fsContainer = document.getElementById('fast-simon-serp-app');
                if(elementPosition === 'before') { // before grid element
                    fsContainer.parentNode.insertBefore(sectionElement, fsContainer);
                } else { // after 
                    fsContainer.insertAdjacentElement('afterend', sectionElement);
                }
            }
        }
        
        document.body.classList.remove('menuOpen');
    };
    
    function beforeNavigation(event) {
        var dropdownMenuEl = document.querySelector('.is-dropdown-open');
        if(dropdownMenuEl) {
            dropdownMenuEl?.querySelector('.mega-menu').setAttribute('aria-hidden', true);
        }
        
        var excludedCollections =   ['decor','fun-flatables','mah-valous-marvel','kids-marvel-comics','kids-star-wars','black-widow','falcon-the-winter-soldier','shang-chi','mandalorian','star-wars','star-trek','top-gun','addams-family','beetlejuice','charlie-and-the-chocolate-factory','teenage-mutant-ninja-turtles','the-wizard-of-oz','antman-the-wasp','avengers','black-panther','captain-marvel','deadpool','guardians-of-the-galaxy','justice-league','marvel-comics','spiderman','venom','wonder-woman','x-men','a-nightmare-on-elm-street','five-nights-at-freddys','friday-the-13th','baby-shark','despicable-me','paw-patrol','sonic-the-hedgehog','adult-marvel-comics','adult-star-wars','flash','new-decor','animatronics','family-friendly-decor','graveyard-tombstones','lighting-special-effects','rodents-animals','scary-decor','skulls-skeletons','spiders-webs','comics-superheroes-collections','wall-window-decor','horror-collections','all-decor','mariahcareyholidaycollection','elvis','decades','haulathon','ted-lasso','willy-wonka','jojo-siwa','smurfs','thor','inflatable-decorations','pumpkins','star-wars-marvel-costumes','animal-costumes','career-costumes','pirate-costumes','funny-costumes','fairytale-storybook-costumes','renaissance-medieval-costumes','celebrities-music','blue-beetle','dune','the-jetsons','coca-cola','m3gan','licensed-decorations','outdoor-decorations','indoor-decorations','oversized-decorations','the-nightmare-before-christmas','wednesday-addams-nevermore-costumes-accessories','gemmy-decorations','bloody-mess-decorations','all-star-wars','all-elf-movie'];
        
        var splatted = event.target.dataset?.url?.split('/');
        var collectionName = splatted?.[splatted.length-1];
        if(excludedCollections.includes(collectionName)) {
            window.location.href = event.target.dataset.url;
        } else {
            $('[data-section-type="slideshow"]').parent('.shopify-section').remove();
            
            setTimeout(function(){
                $('[data-section-type="slideshow"]').parent('.shopify-section').remove();
            },500);
        }
        
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    
    var __fast_options  = { after_spa_navigation_callback: afterNavigation, before_spa_navigation_callback: beforeNavigation, full_spa: true};
